/**
 * Validates a US-style phone number string. Yields false for an empty value, otherwise tests it against a pattern allowing an optional parenthesized area code and space or dash separators.
 *
 * @param value - Phone number text to validate.
 * @returns True when the value matches the accepted phone number shape.
 */
export const checkPhoneNumber = (value: string) => {
  if (!value) {
    return false;
  }
  const isVail = /^((\([0-9]{3}\))|[0-9]{3})[\s\\-]?[\0-9]{3}[\s\\-]?[0-9]{4}$/.test(value);
  if (!isVail) {
    return false;
  }
  return true;
};

/**
 * Validates an email address string. Trims and lowercases the input before testing it against a pattern accepting quoted local parts, bracketed IPv4 hosts and dotted domain names.
 *
 * @param email - Email address text to validate.
 * @returns True when the address matches the accepted email shape.
 */
export const validateEmail = (email: string) => {
  const re =
    /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).trim().toLowerCase());
};
